import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { NavDropdown, Nav, Navbar, Container, Button} from 'react-bootstrap';
import Pengaturan from './components/pengaturan';
import { useHistory } from 'react-router-dom';
function Header(){
  const history = useHistory();
  const token = localStorage.getItem("token");
  const menu=[['dashboard','Dashboard'],['billing','Billing'],['customer','Customer'],['scheduler','Scheduler']];
  const [tampilMenu, setTampilMenu]=useState('');
  const [selectRouter, setSelectRouter] = useState();
  const logoutHandler = async () =>{
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      await axios.post(Pengaturan['urlApi']+'logout')
      .then((response)=>{
          localStorage.removeItem("rtr");
          localStorage.removeItem("token");
          localStorage.removeItem("router");
          localStorage.removeItem("title");
          localStorage.removeItem("alamat");
          window.location.reload();
      })
  }
  useEffect(()=>{
    showMenu();
  },[]);
  const showMenu=()=>{
    let mn=[];
    for(let x=0; x<menu.length; x++){
      mn.push(<Nav.Link href={Pengaturan['baseurl']+menu[x][0]} onClick={(x)=>pilihmenu(x)} className='active'>{menu[x][1]}</Nav.Link>);
    }
    setTampilMenu(
      <>
        {mn}
          <NavDropdown title="PPP" id="basic-nav-dropdown" className='active'>
              <NavDropdown.Item href={Pengaturan['baseurl']+'activeconnection'}>Active Connection</NavDropdown.Item>
              <NavDropdown.Item href={Pengaturan['baseurl']+"pppsecret"}>Secret</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Profile
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Interface</NavDropdown.Item>
          </NavDropdown>
      </>
    );
    setSelectRouter(
      <><select defaultValue={localStorage.getItem('rtr')} onChange={(event)=>onChangeSlct(event.target.value)}>
        <option value="1">Rancah</option>
        <option value="2">Bayasari</option>
        <option value="3">Tambaksari</option>
      </select>
      </>);
  }
  const onChangeSlct=(val)=>{
    localStorage.setItem('rtr',val);
    history.push(Pengaturan['baseurl']);
  }
  const pilihmenu=(x)=>{
    localStorage.setItem('title',menu[x][1]);
  }
 
  return(
    <Navbar fixed="top" bg="dark" variant="dark" expand="lg">
      <Container>
      
      <Navbar.Brand>{selectRouter}</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          {tampilMenu}                  
        </Nav>
        
        <Button onClick={logoutHandler} className='btn btn-danger justify-content-end'>Logout</Button>
        
      </Navbar.Collapse>
      </Container>
  </Navbar>
    )
}
export default Header;